import { useEffect, useState } from 'react'
import service from '../services/service'
import endpoints from '../services/endpoints'

// GET /admin-panel/app-options/list?group=<code> — a single generic endpoint
// backing many unrelated dropdowns app-wide (venue_pricing_type, coupon_category,
// room_type, etc.), each row shaped {id, group, value, label, icon}.
const useAppOptions = (group) => {
    const [options, setOptions] = useState([])

    useEffect(() => {
        if (!group) return
        service
            .get(endpoints.adminPanel.appOptions, { group }, { silent: true })
            .then(({ data }) => setOptions(Array.isArray(data?.data) ? data.data : []))
            .catch(() => setOptions([]))
    }, [group])

    return options
}

export default useAppOptions
